import { useAuth } from "../../use-auth";
import { ROLES, type Role } from "@/constants/roles";

export function useUserRoles() {
	const { user } = useAuth();

	const hasRole = (role: Role): boolean => {
		if (!user || !user.roles) return false;

		return user.roles.includes(role);
	};

	// TODO: temporary solution until we have a proper role/permission system
	const hasAccess = (requiredRole: Role): boolean => {
		if (!user || !user.roles) return false;

		if (requiredRole === ROLES.ADMIN) return hasRole(ROLES.ADMIN);
		if (requiredRole === ROLES.FLEET_MANAGER)
			return hasRole(ROLES.ADMIN) || hasRole(ROLES.FLEET_MANAGER);

		return (
			hasRole(ROLES.ADMIN) ||
			hasRole(ROLES.FLEET_MANAGER) ||
			hasRole(ROLES.DRIVER)
		);
	};

	return {
		hasAccess,
		hasRole,
		roles: user?.roles ?? [],
	};
}
